import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LandingForm } from '../../../../../../domain/landing-config.interface';
import { formCode } from '../landing-utils';

// Card compacta: número + "Abrir" arriba, título y código abajo (diseños 4 y 5)
@Component({
  selector: 'app-landing-compact-card',
  templateUrl: './landing-compact-card.component.html',
  styleUrls: ['./landing-compact-card.component.scss'],
})
export class LandingCompactCardComponent {
  @Input() form: LandingForm;
  // pink: fondo rosa claro y borde rosa (diseño 4); white: fondo blanco y borde gris (diseño 5)
  @Input() variant: 'pink' | 'white' = 'pink';
  @Output() open = new EventEmitter<LandingForm>();

  formCode = formCode;
}
